import { Link } from "react-router-dom";
import { Panel } from "@/components/Bits";
import { useFetch, fmtDate, BRL } from "@/lib/useFetch";

const Box = ({ label, value, testId, cls = "bg-white" }) => (
  <div className={`rounded-2xl border border-[#E2DDD3] p-4 ${cls}`} data-testid={testId}>
    <p className="text-[11px] font-bold uppercase tracking-wider opacity-80">{label}</p>
    <p className="font-display text-2xl font-extrabold mt-1">{typeof value === "number" && !label.startsWith("OS") ? BRL(value) : value}</p>
  </div>
);

export const ResumoFin = ({ mes, version }) => {
  const { data } = useFetch(mes ? "/financeiro/resumo" : null, { mes, v: version });
  if (!data) return null;
  const saldo = data.faturamento + data.recebido - data.pago - data.comissoes_bonus;
  return (
    <div className="space-y-4" data-testid="fin-resumo">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Box label="Faturamento (OS encerradas)" value={data.faturamento} cls="bg-[#1E4D2B] text-white" testId="fin-faturamento" />
        <Box label="OS encerradas" value={data.os_finalizadas} testId="fin-os-count" />
        <Box label="Serviços" value={data.servicos} testId="fin-servicos" />
        <Box label="Peças" value={data.pecas} testId="fin-pecas" />
        <Box label="A receber (em aberto)" value={data.a_receber} testId="fin-a-receber" />
        <Box label="Recebido (lançamentos)" value={data.recebido} testId="fin-recebido" />
        <Box label="A pagar (em aberto)" value={data.a_pagar} cls="bg-[#F5E6E0]" testId="fin-a-pagar" />
        <Box label="Pago (lançamentos)" value={data.pago} testId="fin-pago" />
        <Box label="Comissões e bônus do mês" value={data.comissoes_bonus} testId="fin-comissoes" />
        <Box label="Resultado estimado" value={saldo} cls="bg-[#FAF8F5]" testId="fin-resultado" />
      </div>
      <Panel title={`OS encerradas no mês (${data.ordens.length})`} testId="fin-os-list">
        {data.ordens.length === 0 ? <p className="text-[#5C6B66]">Nenhuma OS encerrada neste mês.</p> : (
          <ul className="divide-y divide-[#E2DDD3]">{data.ordens.map((o) => (
            <li key={o.os_id} className="py-3 flex justify-between gap-3">
              <Link to={`/ordens-servico/${o.os_id}`} className="min-w-0 truncate hover:underline"><b>{o.numero}</b> · {o.cliente_nome} <span className="text-xs text-[#5C6B66]">{fmtDate(o.finalizada_em)}</span></Link>
              <b className="text-[#1E4D2B] shrink-0">{BRL(o.total)}</b>
            </li>))}</ul>
        )}
      </Panel>
    </div>
  );
};
